import { Link } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { t } from '@/locales/i18n';

export function ForbiddenPage(): JSX.Element {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-secondary/40 px-4 text-center">
      <ShieldAlert className="mb-4 h-12 w-12 text-destructive" />
      <h1 className="text-xl font-semibold">{t('errors.forbidden.title')}</h1>
      <p className="mt-1 max-w-md text-sm text-muted-foreground">{t('errors.forbidden.message')}</p>
      <Button asChild className="mt-6">
        <Link to="/">{t('nav.dashboard')}</Link>
      </Button>
    </div>
  );
}
